// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../../ContactBand";

export default function CaseDefi() {
  return (
    <main>
      <section className="page-hero ground cd-hero" data-en="WORKS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/cases">実績・事例</Link>
            <span>DeFi運用の仕組みづくり</span>
          </nav>
          <div className="case-tags cd-tags">
            <span>金融・暗号資産</span>
            <span>ブロックチェーン事業開発</span>
          </div>
          <h1 className="cd-title">
            DeFi運用を安全に任せられる、ウォレット制御と自動リバランスの設計
          </h1>
          <p className="cd-client">暗号資産運用会社</p>
          <div className="cd-img is-cover">
            <span className="cover-en">DeFi OPERATION</span>
            <span className="cover-ja">DeFi × ウォレット設計</span>
          </div>
          <div className="cd-summary">
            <div>
              <span>課題</span>
              <p>
                毎日1〜3時間かかるDeFi運用を、資産の流出を防ぎながら社内に任せたい。
              </p>
            </div>
            <div>
              <span>解決策</span>
              <p>
                ウォレットの機能制限と、自動リバランスの実装方式を調査・設計。
              </p>
            </div>
            <div>
              <span>成果</span>
              <p>
                運用額と求める柔軟性に応じた構成（Safe /
                Fireblocks）と自動化の方針を提示。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="cd-body container">
          <section className="cd-sec">
            <h2>プロジェクト概要</h2>
            <p>
              法人でDeFi運用（主にUniswap
              v3での流動性提供）を行う企業に対し、運用の一部を安全に社内メンバーへ任せるためのウォレット構成と、ポジション調整を自動化する方式を調査・設計しました。
            </p>
          </section>
          <section className="cd-sec">
            <h2>お客様の課題</h2>
            <ul className="cd-list">
              <li>
                DeFiのポジション管理に毎日1〜3時間かかり、社内メンバーに任せたい
              </li>
              <li>
                任せる際に、外部への送付や意図しない取引による資産の流出を防ぎたい
              </li>
              <li>
                価格の変化にリアルタイムで対応できず、インパーマネントロスが発生していた
              </li>
              <li>
                ポジション調整のスワップを、プールの価格に影響しない形で行いたい
              </li>
            </ul>
          </section>
          <section className="cd-sec">
            <h2>LEAPSの対応</h2>
            <div className="cd-point">
              <span className="cd-num">01</span>
              <div>
                <p className="cd-cat">ウォレット設計</p>
                <h3 className="cd-ptitle">
                  送付先・プロトコル・通貨を制限できる構成
                </h3>
                <p>
                  指定アドレス以外への送付不可、特定プロトコルへのアクセスだけ許可、といった制限を実現できる構成を調査。Safe（マルチシグ）とFireblocks（MPC）を、対応チェーン・ハードウェアウォレット対応・費用などで比較しました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">02</span>
              <div>
                <p className="cd-cat">自動化の設計</p>
                <h3 className="cd-ptitle">
                  自動リバランスと自動スワップの実装方式
                </h3>
                <p>
                  Uniswap
                  v3向けの自動リバランスVault、コントラクトの自動実行サービス、独自実装の3つの方式を比較し、組み合わせ方を設計しました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">03</span>
              <div>
                <p className="cd-cat">リスク評価</p>
                <h3 className="cd-ptitle">セキュリティリスクと対策の整理</h3>
                <p>
                  再入攻撃、MEVボット、オラクルへの攻撃など、自動化にともなうリスクと対策を整理しました。
                </p>
              </div>
            </div>
          </section>
          <section className="cd-sec">
            <h2>成果</h2>
            <p>
              運用額が大きくセキュリティを重視する場合はFireblocks、制限の柔軟性を重視する場合はSafeという推奨構成と、「自動リバランスは実績のあるVaultを利用し、自動スワップはAPIと独自ロジックで実装する」という自動化の方針を提示しました。
            </p>
          </section>
        </div>
      </section>
      <section className="section ground">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            ほかの事例<strong>Other Works</strong>
          </h2>
          <div className="case-grid">
            <Link className="case-card" to="/cases/anybound">
              <div className="case-img">
                <img
                  src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
                  alt=""
                />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                希少な旅行体験をブロックチェーンで流通させる共創プロジェクト「anyBOUND」
              </h3>
              <div className="case-tags">
                <span>エンタープライズ</span>
                <span>ブロックチェーン事業開発</span>
                <span>共創プロジェクト</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/kanda-curry">
              <div className="case-img is-cover">
                <span className="cover-en">NFT STAMP RALLY</span>
                <span className="cover-ja">スタンプラリー × NFT</span>
              </div>
              <p className="case-meta">広告代理店</p>
              <h3>
                スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」
              </h3>
              <div className="case-tags">
                <span>イベント・観光</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/premience">
              <div className="case-img">
                <img src="/assets/images/case-premience.jpg" alt="" />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                JTBのラグジュアリー体験ブランド「プレミエンス」のロゴ制作とサイトリニューアル
              </h3>
              <div className="case-tags">
                <span>旅行・観光</span>
                <span>ブランディング・Web制作</span>
              </div>
            </Link>
          </div>
          <div className="more">
            <Link to="/cases">実績一覧を見る →</Link>
          </div>
        </div>
      </section>
      <ContactBand ground={false} />
    </main>
  );
}
